import { render, staticRenderFns } from "./TlmCheckoutMenu.vue?vue&type=template&id=20d9184a"
import script from "./TlmCheckoutMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TlmCheckoutMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TlmCheckoutMenu.vue?vue&type=style&index=0&id=20d9184a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports